import shop from '../../api/paymentHistory';
import {request_detail, request_list} from '@/commons/hpod';
import { sendSuccessNotice, sendErrorNotice, refreshResource } from '@/commons/utils';
import Vue from 'vue';
const endpoint = 'payment_histories'
const viewTitle = 'Lịch sử thanh toán'
// initial state
const state = {
    loading: false,
    all: {},
    selected: {
        Packages: []
    },
    packageByRef: []
};

// getters
const getters = {};

// actions
const actions = {
    getPaymentHistoryList({ commit }, param) {
        commit("setLoading", { loading: true });
        shop.getPaymentHistoryList(data => {
            commit('setPaymentHistoryList', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getPaymentHistoryDetail({ commit }, paymentID) {
        commit("setLoading", { loading: true });
        shop.getPaymentHistoryDetail(data => {
            commit('setPaymentHistoryDetail', data);
            commit("setLoading", { loading: false });
        }, Vue.http, paymentID, this.state.authentication.token);
    },
    getPackageByRef({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('bigpackagebyref', data => {
            commit('setPackageByRef', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getDetail({ commit }, {id, params}) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                    commit("setLoading", { loading: true });
                    request_detail(endpoint, item => {
                        commit('setDetail', item);
                        commit("setLoading", { loading: false });
                        resolve(item.data ? item.data : item);
                        if(params && params.action) {
                            refreshResource();
                        }
                }, Vue.http, id, this.state.authentication.token, params);
            }, 100)
        })
    },
};

// mutations
const mutations = {
    setPaymentHistoryList(state, data) {
        state.all = data;
    },
    setPaymentHistoryDetail(state, item) {
        state.selected = item.data;
    },
    setPackageByRef(state, item) {
        state.packageByRef = item.data;
    },
    setLoading(state, { loading }) {
        state.loading = loading;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
